import { Container } from '@goldbely/explore-component-library';
import React, { useState, FC } from 'react';
import clsx from 'classnames';

import { useEscape } from 'src/explore/hooks/useEscape';

import MobileMenuToggle from '../../../../atoms/MobileMenuToggle';
import { IPrizeMerchant, IWebLink } from '../../../../types';
import Logo from './atoms/Logo';
import Buttons from './molecules/Buttons';
import Navigation from './molecules/Navigation';

import styles from './index.module.sass';

interface AragostaProps {
  className?: {
    container?: string;
  };
  links?: IWebLink[];
  merchant: IPrizeMerchant;
}

const Aragosta: FC<AragostaProps> = ({ className, links, merchant }) => {
  const [ isMobileMenuActive, setIsMobileMenuActive ] = useState( false );

  const handleToggleMobileMenu = () => {
    setIsMobileMenuActive( !isMobileMenuActive );
  };

  useEscape(() => setIsMobileMenuActive( false ));

  return (
    <div className={clsx( styles.wrap, className?.container )}>
      <Container className={styles.container}>
        <MobileMenuToggle
          className={styles.hamburger}
          isActive={isMobileMenuActive}
          onClick={handleToggleMobileMenu}
        />

        <Logo merchant={merchant} />

        <Navigation
          isActive={isMobileMenuActive}
          links={links}
          merchant={merchant}
          onClose={handleToggleMobileMenu}
        />

        <Buttons />
      </Container>
    </div>
  );
};

export default Aragosta;
